import React from "react";

import { Box } from "arkh";

import { graphql, useFragment } from "react-relay";

import { TaskExecutionFooterTodosComponent_TaskExecution$key } from "./__generated__/TaskExecutionFooterTodosComponent_TaskExecution.graphql";

import { useTodoBottomSheet } from "../../ReportIssueBottomSheet/TodoBottomSheet/TodoBottomSheetProvider";
import { RoutineOccasionTodoIssue } from "../RoutineOccasionScreen/RoutineOccasionTodoIssue";

function TaskExecutionFooterTodosCMP(props: {
  taskExecution: TaskExecutionFooterTodosComponent_TaskExecution$key;
}) {
  const data = useFragment(
    graphql`
      fragment TaskExecutionFooterTodosComponent_TaskExecution on TaskExecution {
        id
        todos {
          id
          ...RoutineOccasionTodoIssue_todo
        }
      }
    `,
    props.taskExecution
  );

  const todoBottomSheet = useTodoBottomSheet();

  if (data.todos.length === 0) {
    return <Box spaceBottom={"medium"} />;
  }
  return (
    <Box style={{ flex: 1 }}>
      {data.todos.map(function (todo, i) {
        if (!todo) {
          console.log("render empty issue");
          return null;
        }
        return (
          <RoutineOccasionTodoIssue
            key={todo.id}
            isFirst={i === 0}
            isLast={i === data.todos.length - 1}
            todo={todo}
            openTodo={() => {
              todoBottomSheet.present(false, todo.id);
            }}
          />
        );
      })}
    </Box>
  );
}
export const TaskExecutionFooterTodos = React.memo(TaskExecutionFooterTodosCMP);
